export class SessionExpiredError implements Error {
	readonly name = 'HttpErrorResponse';
	readonly message = 'Session has expired, please login again!';
	constructor() {}
}
